// AUTO GENERATED FILE - Changes WILL be lost.
// zh-CN - used as 'zh' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "投注单",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "下注",
  "betslip.clear": "全部清除",
  "betslip.clearResult": "清除",
  "betslip.noSelections": "添加选项以开始投注",
  "betslip.notLoggedIn": "登录以开始投注",
  "betslip.refresh": "刷新",
  "betslip.totalStake": "总投注金",
  "betslip.noHistoryData": "无投注信息",
  "betslip.openBets": "投注未结算",
  "betslip.betHistory": "下注纪录",
  "betslip.betHistoryWon": "赢",
  "betslip.betHistoryLost": "输",
  "loading.loading": "加载中",
  "loading.account": "登录帐号中",
  "loading.league": "载入联赛",
  "loading.gameweeks": "载入比赛时间表",
  "loading.markets": "载入盘口",
  "loading.bethistory": "正在加载下註紀錄",
  "login.loginRequired": "需要登录",
  "login.loginToBet": "请登录以开始投注",
  "navigation.back": "返回",
  "navigation.close": "关闭",
  "video.liveStreamAvailable": "直播可用",
  "video.logInToWatch": "请登录观看",
  "error.error": "错误",
  "error.404": "网页未找到",
  "error.gameLaunchFailed": "无法启动",
  "error.unknownErrorCode": "未知错误: {code}",
  "error.minUnitStakeLimitExceeded": "最低投注额 {limit}",
  "error.maxUnitStakeLimitExceeded": "最高投注额 {limit}",
  "error.minTotalStakeLimitExceeded": "最低投注总额 {limit}",
  "error.maxTotalStakeLimitExceeded": "最高投注总额 {limit}",
  "error.notPlaced": "未投注",
  "error.wagerDisallowed": "禁止下注",
  "error.errorEventIsOff": "赛事已开始",
  "multiplebet.Singles": "单式投注",
  "multiplebet.Doubles": "二串一",
  "multiplebet.Trebles": "三串一",
  "multiplebet.Accumulator": "累计",
  "multiplebet.Perm 4-Folds": "四串一",
  "multiplebet.Perm 5-Folds": "五串一",
  "multiplebet.Perm 6-Folds": "六串一",
  "multiplebet.Perm 7-Folds": "七串一",
  "multiplebet.Perm 8-Folds": "八串一",
  "multiplebet.Perm 9-Folds": "九串一",
  "sb-english.team.ARS": "阿森纳",
  "sb-english.team.AST": "阿思顿维拉",
  "sb-english.team.BHA": "布来顿",
  "sb-english.team.BOU": "博尼茅斯",
  "sb-english.team.BUR": "伯恩利",
  "sb-english.team.CHE": "切尔西",
  "sb-english.team.CRY": "C. 宫",
  "sb-english.team.EVE": "埃弗顿",
  "sb-english.team.LEI": "莱切斯特",
  "sb-english.team.LIV": "利物浦",
  "sb-english.team.MNC": "曼彻斯特. C",
  "sb-english.team.MNU": "曼彻斯特联盟",
  "sb-english.team.NEW": "纽卡斯尔",
  "sb-english.team.SOU": "南安普敦",
  "sb-english.team.TOT": "托特纳姆",
  "sb-english.team.WAT": "沃特福德",
  "sb-english.team.WHU": "西汉姆",
  "sb-english.team.WOL": "伍尔弗",
  "sb-english.team.NOR": "诺维奇",
  "sb-english.team.SHU": "谢菲尔德. U",
  "sb-english.team.LEE": "利兹",
  "sb-english.team.FUL": "富勒姆",
  "sb-english.team.WBA": "西布罗姆",
  "nomorebets": "投注结束",
  "playtime": "上场时间",
  "gameId": "赛事ID",
  "noGames": "无可用赛事，请稍后再回来查看",
  "Home": "主",
  "Away": "客",
  "Visitor": "客",
  "soccerbet.gameWeek": "赛事周",
  "soccerbet.noGameWeeks": "没有比赛时间表，请稍后再查看",
  "soccerbet.league": "联赛排名",
  "soccerbet.table.name": "名称",
  "soccerbet.table.won": "赢",
  "soccerbet.table.drawn": "和",
  "soccerbet.table.lost": "输",
  "soccerbet.table.points": "比分",
  "market.abbr.Both Teams To Score": "两队得分",
  "market.Both Teams To Score": "两队都进球",
  "market.Over / Under": "大/小",
  "market.Double Chance": "双重机会",
  "market.Match Result": "比赛结果",
  "market.Exact Goals": "正确比分",
  "market.Correct Score": "波胆",
  "market.Match Result Both Score": "比赛结果双方得分",
  "market.Result Und/Over 1.5 Total Goals": "赛事结果/小 1.5 总分",
  "market.Result Und/Over 2.5 Total Goals": "赛事结果大/小 2.5 总分",
  "market.Under Over 1.5 Total Goals": "大/小1.5 总分",
  "market.Under Over 2.5 Total Goals": "大/小2.5 总分",
  "market.Under Over 3.5 Total Goals": "大/小3.5 总分",
  "market.Under Over 4.5 Total Goals": "大/小4.5 总分",
  "market.Total Goals 1 To 2": "总进球数1至2",
  "market.Total Goals 1 To 3": "总进球数1至3",
  "market.Total Goals 1 To 4": "总进球数1至4",
  "market.Total Goals 2 To 3": "总进球数2至3",
  "market.Total Goals 2 To 4": "总进球数2至4",
  "market.Under Over 1.5 Home Goals": "大/小 1.5 主队得分",
  "market.Under Over 1.5 Away Goals": "大/小 1.5 客队得分",
  "market.Home Team Exact Goals": "主队正确比分",
  "market.Away Team Exact Goals": "客队正确比分",
  "selection.Yes": "是",
  "selection.No": "否",
  "selection.1+G": "1+进球",
  "selection.1+Ng": "1+没有进球",
  "selection.X+G": "X+进球",
  "selection.X+Ng": "X+没有进球",
  "selection.2+G": "2+进球",
  "selection.2+Ng": "2+没有进球",
  "selection.1+Yes": "1+是",
  "selection.1+No": "1+否",
  "selection.X+Yes": "X+是",
  "selection.X+No": "X+否",
  "selection.2+Yes": "2+是",
  "selection.2+No": "2+否",
  "selection.TID_ANY_GOAL_SCORED_YES": "进球",
  "selection.TID_ANY_GOAL_SCORED_NO": "没有进球",
  "selection.U": "小",
  "selection.O": "大",
  "selection.1+O": "1+大",
  "selection.X+O": "X+大",
  "selection.2+O": "2+大",
  "selection.1+U": "1+小",
  "selection.X+U": "X+小",
  "selection.2+U": "2+小",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12"
}
